import {Component, OnInit} from '@angular/core';

import {Recurso} from "./recurso";
import {AppComponent} from "../app.component";
import {QuestionService} from '../question/question.service';
import {TrabalhoService} from '../trabalho/trabalho.service';

declare var jQuery: any;

@Component({
  selector: 'app-pedir-recurso',
  templateUrl: './pedir-recurso.component.html',
  styleUrls: ['./pedir-recurso.component.css']
})

export class PedirRecursoComponent extends AppComponent implements OnInit {

	itens: Array<any>;
	recurso: Recurso = new Recurso();
	desabilitado: boolean;

	ngOnInit(): void {
		if (!this.islogged()) 
            this.router.navigateByUrl('acesso');
		else {
			let trabalhoId: number;
			this.route.params.subscribe(params => trabalhoId = +params['id_t']);
		    this.recursoService.retornarRecurso(trabalhoId).then(recurso => {
				this.trabalhoService.getTrabalho(trabalhoId).then(trabalho => {
					this.questionService.getQuestions(trabalho.evento_id).then(perguntas => {
						this.itens = new Array(perguntas.length);
						if (recurso.id) {
							this.recurso = recurso;
							jQuery("form :input").prop("disabled", this.desabilitado = true);
							jQuery("form :input").prop("readonly", true);
							jQuery("#voltar").prop("disabled", false);
						} else {		
							recurso = new Recurso();
							this.recurso.trabalho_id = trabalhoId;
						}
					});
				});		
			});
			
		}
	}
	
	onSubmit(): void {
		if (this.recurso.item_1 == this.recurso.item_2)
			this.utils.exibirMensagem("Os itens escolhidos devem ser diferentes!", 'warning');
		else
			this.recursoService.pedirRecurso(this.recurso).then(response => this.goBack());
	}

}



// WEBPACK FOOTER //
// ./src/app/pedir-recurso/pedir-recurso.component.ts